import {EnsembleUsersQuery} from "@/graphql/types";

export type UserOrInvitation = EnsembleUsersQuery["user_ensembles"][0] | EnsembleUsersQuery["user_invitations"][0];

export function isInvitation(
  userOrInvitation: UserOrInvitation,
): userOrInvitation is EnsembleUsersQuery["user_invitations"][0] {
  return (userOrInvitation as EnsembleUsersQuery["user_invitations"][0]).user_email !== undefined;
}
